// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center[data-v-fae5bece] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -150px;\n  margin-top: -50px;\n}\n", ""]);
// Exports
module.exports = exports;
